import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6dc5e523")

_pushScopeId("data-v-6dc5e523")
const _hoisted_1 = { class: "main__section" }
const _hoisted_2 = { class: "legal" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Privacy = _resolveComponent("Privacy")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_Agreement = _resolveComponent("Agreement")
  const _component_TabView = _resolveComponent("TabView")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_TabView, {
        activeIndex: _ctx.selectPage,
        "onUpdate:activeIndex": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectPage = $event))
      }, {
        default: _withId(() => [
          _createVNode(_component_TabPanel, {
            header: "개인정보 처리방침",
            class: "legal__privacy"
          }, {
            default: _withId(() => [
              _createVNode(_component_Privacy)
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, {
            header: "이용약관",
            class: "legal__agreement"
          }, {
            default: _withId(() => [
              _createVNode(_component_Agreement)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["activeIndex"])
    ])
  ]))
})